import { render, staticRenderFns } from "./ContactPictureEdit.vue?vue&type=template&id=dd3ae91a&scoped=true&"
import script from "./ContactPictureEdit.vue?vue&type=script&lang=js&"
export * from "./ContactPictureEdit.vue?vue&type=script&lang=js&"
import style0 from "./ContactPictureEdit.vue?vue&type=style&index=0&id=dd3ae91a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd3ae91a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VBtn,VCol,VIcon,VRow,VSpacer})
